import React, { useRef, useState, useContext } from 'react';
import { navigate } from '@reach/router';

import { makeStyles } from '@material-ui/core/styles';
import Alert from '@material-ui/lab/Alert';
import AlertTitle from '@material-ui/lab/AlertTitle';
import Avatar from '@material-ui/core/Avatar';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Container from '@material-ui/core/Container';
import CssBaseline from '@material-ui/core/CssBaseline';
import Grid from '@material-ui/core/Grid';
import Link from '@material-ui/core/Link';
import MailOutlineIcon from '@material-ui/icons/MailOutline';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';

import Copyright from '../Copyright';
import AuthContext from '../../services/firebase/AuthContext';

const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(3),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
}));

const PasswordResetPage = ({ email }) => {
  const classes = useStyles();
  const emailRef = useRef(email);

  const [message, setMessage] = useState();
  const [waiting, setWaiting] = useState(false);

  const { reset } = useContext(AuthContext);

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!emailRef.current.value) {
      setMessage({ title: 'One thing ...', severity: 'warning', message: `Please enter a valid email address`, handleClose: () => setMessage(undefined) });
    }

    try {
      reset(emailRef.current.value)
        .then(() => {
          setMessage({ title: 'Success!', severity: 'success', message: `Reset instructions have been sent to your email address. If they don't arrive shortly please check your spam foolder`, handleClose: () => navigate("/signin") });
        })
        .catch(error => {
          setMessage({ title: 'There was a problem ...', severity: 'danger', message: `An error occurred sending your reset email: ${error.message}`, handleClose: () => setMessage(undefined) });
        })
    }
    catch (error) {
      setMessage({ title: 'There was a problem ...', severity: 'danger', message: `An error occurred sending your reset email: ${error.message}`, handleClose: () => setMessage(undefined) });
    }

    setWaiting(false);
  }

  const ResetForm = () => {
    return (
      <form className={classes.form} onSubmit={handleSubmit}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TextField
              inputRef={emailRef}
              defaultValue={email || ''}
              variant="outlined"
              required
              fullWidth
              id="email"
              label="Email Address"
              name="email"
              autoComplete="email"
            />
          </Grid>
        </Grid>
        {
          message &&
          <Alert
            variant="filled"
            severity={message.severity}
            onClose={message.handleClose}
            style={{ marginTop: '1rem', marginBottom: '0.5rem' }}
          >
            <AlertTitle>{message.title}</AlertTitle>
            {message.message}
          </Alert>
        }
        {
          !message &&
          <Button
            disabled={waiting}
            type="submit"
            fullWidth
            variant="contained"
            color="primary"
            className={classes.submit}
          >Send me a Reset link
          </Button>
        }
        <Grid container justify="flex-end">
          <Grid item>
            <Link href="/signin" variant="body2">
              Remembered it? Sign in
            </Link>
          </Grid>
        </Grid>
      </form>
    )
  }

  return (
    <Container component="main" maxWidth="xs">
      <CssBaseline />
      <div className={classes.paper}>
        <Typography component="h1" variant="h6">The Intermediary Cooperative</Typography>
        <Avatar className={classes.avatar}>
          <MailOutlineIcon />
        </Avatar>
        <Typography component="h1" variant="h5">
          Password Reset
        </Typography>
        <ResetForm />
      </div>
      <Box mt={5}>
        <Copyright />
      </Box>
    </Container>
  );

}

export default PasswordResetPage;